import { StringHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { SectionDto } from "../../../services/dto";
import * as yup from "yup";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

interface QuestionnaireSectionFormProps {
  data?: SectionDto | undefined;
  show: boolean;
  loading?: boolean;
  onHide: () => void;
  onSave: (values: SectionDto) => DrawerFormSaveResult;
  questionnaireId?: string | undefined;
}

const validationSchema = yup.object().shape({
  questionnaireId: yup.string().required("Community is required."),
  name: yup.string().required("Name is required."),
  description: yup.string().required("Description is required."),
  order: yup
    .number()
    .required("Section order is required.")
    .min(0, "Please enter valid section order."),
  startDate: yup
    .date()
    .typeError("Please enter a valid date.")
    .nullable()
    .required("Start date is required."),
  endDate: yup
    .date()
    .typeError("Please enter a valid date.")
    .nullable()
    .test({
      name: "Is end date greater",
      exclusive: false,
      params: {},
      message: "End date must be after start date",
      test: function (value) {
        if (value) {
          if (!this.parent.startDate) return true;
          return value >= this.parent.startDate;
        }
        return true;
      },
    }),
});

export const SectionForm = (props: QuestionnaireSectionFormProps) => {
  let questionnaireSection: SectionDto | undefined = props.data;

  const title: string =
    StringHelper.whenNullOrEmpty(
      questionnaireSection?.id,
      Constants.emptyGuid
    ) === Constants.emptyGuid
      ? "New Section"
      : "Edit Section";

  const onSubmit = (data: SectionDto) => {
    return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };

  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      title={title}
      initialValues={
        questionnaireSection ?? { questionnaireId: props.questionnaireId }
      }
      validationSchema={validationSchema}
      on_Submit={onSubmit}
      enableReinitialize
    >
      <Form.Text name="name" label="Name" isLoading={props.loading} />
      <Form.TextArea
        name="description"
        rows={3}
        label="Description"
        isLoading={props.loading}
      />
      <Form.Number
        min={1}
        name="order"
        label="Order"
        isLoading={props.loading}
      />
      <Form.Date
        name="startDate"
        label="Start Date"
        isLoading={props.loading}
        placeholder="Enter date"
      />
      <Form.Date
        name="endDate"
        label="End Date"
        isLoading={props.loading}
        placeholder="Enter date"
        useStartDateForMin="startDate"
      />
    </Drawer.Form>
  );
};
